<div class="lds-wrap">
	<div class="lds-dual-ring"></div>
</div>
<router-outlet></router-outlet>